import { render, staticRenderFns } from "./_13.vue?vue&type=template&id=51acf8b2&scoped=true&"
var script = {}
import style0 from "./_13.vue?vue&type=style&index=0&id=51acf8b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51acf8b2",
  null
  
)

export default component.exports